import { VueHeadMixin } from '@unhead/vue/client'
import { createPinia } from 'pinia'
import { createSSRApp } from 'vue'

// @ts-ignore no types here
import { setStore } from '@xcel-next/rendering/src/stores/utils/orc-api.js'
import Paragraphs from '@xcel-next/rendering/src/components/Paragraphs.vue'

import { createRenderingHead } from './create-head.js'

import type { Pinia } from 'pinia'
import type { App, Component } from 'vue'
import type { SSRContext } from '@xcel-next/rendering-tools'

// SSR requires a fresh app instance per request, so we need to create a new app
const getMain = (rootComponent: Component, ssrContext?: SSRContext): { app: App, store: Pinia, head: any } => {
  let app
  if (ssrContext) {
    app = createSSRApp(rootComponent, {
      consentConfig: ssrContext.consentConfig,
      config: ssrContext.config,
      url: ssrContext.url,
      brand: ssrContext.brand,
      authorization: ssrContext.Authorization,
      adSizePrediction: ssrContext.adSizePrediction,
      adDefendScript: ssrContext.adDefendScript,
      crawlerDetected: ssrContext.crawlerDetected
    })
  } else {
    app = createSSRApp(rootComponent)
  }

  const store = createPinia()
  setStore(store)
  app.use(store as any) // suggested by copilot :robot: :clown:

  let head
  if (ssrContext) {
    head = createRenderingHead(true)
    app.use(head)
  } else {
    head = createRenderingHead(false)
    app.use(head)
  }

  // https://unhead.unjs.io/setup/vue/installation#optional-vue-3-options-api
  app.mixin(VueHeadMixin)
  // app.use(UnheadPlugin)

  // in order to avoid dynamic (recursive) imports we need to register paragraphs globally
  app.component('Paragraphs', Paragraphs)

  return { app, store, head }
}

export {
  getMain
}
